// Tab-local presentation handoff. This never establishes identity or entitlement.
(()=>{
 const key='em-welcome-entry-v1',ttl=30*60*1000;
 const name=value=>typeof value==='string'&&value.length<=80&&!/[@<>\u0000-\u001f\u007f]/u.test(value)?value.trim().replace(/\s+/gu,' '):'';
 const topics=Object.freeze(['anxiety','grief','heartbreak','habits','loneliness','purpose','relationships','uncertainty']);
 function create(storage,now=Date.now){
  function read(){try{const entry=JSON.parse(storage.getItem(key)||'null');if(entry?.v===1&&['A','B'].includes(entry.variant)&&Number.isFinite(entry.at)&&now()-entry.at>=0&&now()-entry.at<ttl)return {...entry,name:name(entry.name),topic:entry.variant==='A'&&topics.includes(entry.topic)?entry.topic:''};clear();}catch{}return null;}
  function clear(){try{storage.removeItem(key);}catch{}}
  function write(value){try{storage.setItem(key,JSON.stringify(value));return true;}catch{return false;}}
  function enter(value,{variant='B',topic=''}={}){if(!['A','B'].includes(variant))return false;const entry={v:1,variant,at:now(),name:name(value),status:'entry',topic:variant==='A'&&topics.includes(topic)?topic:''};return write(entry);}
  function started(){const entry=read();return entry?write({...entry,status:'creator'}):false;}
  function greeting({audience,preferredName,privateMode}={}){if(privateMode)return '';return audience==='guest'?read()?.name||'':name(preferredName);}
  return {read,clear,enter,started,greeting};
 }
 globalThis.EnlightenWelcomeSession={create,name,key,ttl,topics};
})();

// Explicit capture only: no SDK autocapture, replay, URLs, forms, profiles or prose.
(()=>{
 const experiment='enlighten_me_introductions_v2',assignmentKey='em-onboarding-assignment-v2';
 const events=Object.freeze(['Landing viewed','Onboarding completed','Creator started','Path created','Registration completed','Account authenticated','Day 1 started','Day 1 completed','Plus checkout started','Plus purchased','Sign-in completed','Returning visitor','Authentication failed','Path save failed','Creator failed']);
 function assignment({storage,enabled=false,random=Math.random}={}){
  if(!enabled)return 'A';
  try{const saved=JSON.parse(storage.getItem(assignmentKey)||'null');if(saved?.experiment===experiment&&['A','B'].includes(saved.variant))return saved.variant;}catch{}
  const variant=random()<.5?'A':'B';try{storage.setItem(assignmentKey,JSON.stringify({experiment,variant}));}catch{}return variant;
 }
 const pendingLandings=new Map();
 function create({variant,distinctId,send,consented=()=>false}={}){
  const seen=new Set();
  const client={capture(event,{audience,onceKey,privateMode=false}={}){
   event=({'Welcome viewed':'Landing viewed','Onboarding viewed':'Landing viewed','Personalized Path created':'Path created','Plus purchase confirmed':'Plus purchased'})[event]||event;
   if(privateMode||!events.includes(event)||!['A','B'].includes(variant)||typeof send!=='function')return false;
   if(!consented()){
    // Only the currently visible landing may be observed after consent. Never
    // queue previous actions, authentication or any content for later capture.
    if(event==='Landing viewed')pendingLandings.set(variant,()=>client.capture(event,{audience,onceKey:'landing'}));
    return false;
   }
   if(event==='Landing viewed'){pendingLandings.delete(variant);onceKey='landing';}
   const id=typeof distinctId==='function'?distinctId(variant):distinctId;
   if(!/^[-a-zA-Z0-9_]{8,80}$/.test(id||''))return false;
   const key=event+':'+(onceKey||'');if(onceKey&&seen.has(key))return false;
   const properties={distinct_id:id,experiment,onboarding_variant:variant,$process_person_profile:false,$geoip_disable:true,...(['guest','free','plus'].includes(audience)?{audience}:{})};
   // onceKey is local deduplication only and is deliberately not transmitted.
   try{Promise.resolve(send({event,properties})).catch(()=>{});if(onceKey)seen.add(key);return true;}catch{return false;}
  }};return client;
 }
 function posthogTransport({projectKey,host='https://eu.i.posthog.com',fetch:request=globalThis.fetch}={}){
  if(!/^https:\/\/(eu|us)\.i\.posthog\.com$/.test(host)||!/^phc_[A-Za-z0-9_-]+$/.test(projectKey||''))return null;
  return value=>request(host+'/i/v0/e/',{method:'POST',credentials:'omit',referrerPolicy:'no-referrer',keepalive:true,headers:{'Content-Type':'application/json'},body:JSON.stringify({api_key:projectKey,...value})});
 }
 let configuration={};const clients=new Map();
 function configure(options={}){configuration={distinctId:options.distinctId,send:options.send,consented:options.consented};clients.clear();}
 function forVariant(variant){if(!clients.has(variant))clients.set(variant,create({...configuration,variant}));return clients.get(variant);}
 const analyticsKey='em-onboarding-analytics-v2',pathKey='em-onboarding-path-v2';
 function consented(){try{const p=globalThis.Shopify?.customerPrivacy;return p?.analyticsProcessingAllowed()===true&&p.currentVisitorConsent().analytics==='yes';}catch{return false;}}
 function browserId(variant){
  if(!consented())return null;
  try{
   let v=JSON.parse(localStorage.getItem(analyticsKey)||'null');
   if(v?.experiment!==experiment||!/^[-a-zA-Z0-9_]{8,80}$/.test(v.id||'')||Date.now()-v.at>60*86400000)v={experiment,id:crypto.randomUUID(),at:Date.now()};
   v.variant=variant;localStorage.setItem(analyticsKey,JSON.stringify(v));return v.id;
  }catch{return null;}
 }
 // The only persisted practice reference is tab local. It contains no content,
 // and is fenced to the authenticated owner before any later completion event.
 function trackPath({id,identity,variant,audience,privateMode}){
  if(privateMode||!consented()||!id||!identity||!['A','B'].includes(variant))return;
  try{const old=JSON.parse(sessionStorage.getItem(pathKey)||'null');if(old?.id===id&&old.identity===identity)return;
   sessionStorage.setItem(pathKey,JSON.stringify({id,identity,variant,at:Date.now(),started:false,completed:false}));
   forVariant(variant).capture('Path created',{audience,privateMode,onceKey:id});
  }catch{}
 }
 function practice(value,{identity,audience,privateMode},started=false){
  try{const v=JSON.parse(sessionStorage.getItem(pathKey)||'null');if(!v)return;
   if(privateMode||!consented()||v.identity!==identity||Date.now()-v.at>60*86400000){sessionStorage.removeItem(pathKey);return;}
   if(value?.journey_book?.id!==v.id)return;
   const send=event=>forVariant(v.variant).capture(event,{audience,privateMode,onceKey:v.id});
   if(started&&value.journey?.day===1&&!v.started){if(send('Day 1 started'))v.started=true;}
   if(value.journey_book.path?.completed_days?.includes(1)&&!v.completed){if(send('Day 1 completed'))v.completed=true;}
   sessionStorage.setItem(pathKey,JSON.stringify(v));
  }catch{}
 }
 function consentChanged(){if(!consented()){try{localStorage.removeItem(analyticsKey);sessionStorage.removeItem(pathKey);}catch{}clients.clear();}else if(globalThis.document?.visibilityState!=='hidden'){for(const capture of [...pendingLandings.values()])capture();}}
 globalThis.EnlightenWelcomeAnalytics={assignment,create,configure,forVariant,posthogTransport,events,experiment,assignmentKey,analyticsKey,pathKey,consented,trackPath,practice};
 configure({distinctId:browserId,consented,send:posthogTransport({host:'https://us.i.posthog.com',projectKey:'phc_wQzG7RsEJn4SSGZD7phjfvkcKZ4HTGpefYoz35vJMQwy'})});
 globalThis.document?.addEventListener?.('visitorConsentCollected',consentChanged);
 if(!globalThis.Shopify?.customerPrivacy)globalThis.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)consentChanged();});
})();

/* Revised A, preview theme only. Reuses the original section, artwork and journal motion. The story lasts 13.5 seconds. */
(function(){
  'use strict';
  var reduced=function(){return window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;};

var scriptUrl=document.currentScript&&document.currentScript.src;function polish(root){

 var brand=root.querySelector('.brand-logo');if(brand){var existingLogo=brand.querySelector('img');var logoUrl=existingLogo&&existingLogo.getAttribute('src');brand.replaceChildren();brand.setAttribute('aria-label','Enlighten Me');var logo=document.createElement('img');logo.src=logoUrl||new URL('enlighten-me-logo-free.png?v=transparent-e114f65',scriptUrl||location.href).href;logo.className='em-approved-logo';logo.alt='Enlighten Me — Ancient wisdom. Made personal.';logo.width=1400;logo.height=465;brand.appendChild(logo);var light=logo.cloneNode();light.className="em-approved-logo em-logo-light-lettering";light.alt="";light.setAttribute("aria-hidden","true");brand.appendChild(light);}

}
  function opening(root){
    var quote=root.querySelector('.scene[data-scene="1"] .quote');
    if(!quote||root.dataset.stage!=='1'||reduced())return;
    var text=quote.textContent,split=text.indexOf('miles')+5,index=0,timer=null,done=false;
    var written=document.createElement('span'),remaining=document.createElement('span');
    var motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    written.setAttribute('aria-hidden','true');remaining.setAttribute('aria-hidden','true');
    remaining.className='em-opening-unwritten';remaining.textContent=text;
    quote.setAttribute('aria-label',text);quote.replaceChildren(written,remaining);
    root.dataset.opening='typing';
    function finish(){if(done)return;done=true;clearTimeout(timer);quote.textContent=text;delete root.dataset.opening;root.removeEventListener('keydown',key);motion.removeEventListener?.('change',changed);}
    function key(event){if(event.key==='Escape'||event.key==='Tab')finish();}
    function changed(event){if(event.matches)finish();}
    root.addEventListener('keydown',key);motion.addEventListener?.('change',changed);
    (function tick(){
      if(done)return;
      written.textContent=text.slice(0,++index);remaining.textContent=text.slice(index);
      if(index<text.length){timer=setTimeout(tick,index===split?600:44);return;}
      timer=setTimeout(function(){root.dataset.opening='question';timer=setTimeout(finish,350);},180);
    })();
  }
  function init(root){
    if(!root||root.dataset.emReady==='true')return;
    root.dataset.emReady='true';polish(root);
    var analytics=globalThis.EnlightenWelcomeAnalytics?.forVariant('A');
    analytics?.capture('Onboarding viewed',{onceKey:'onboarding-landing'});
    var config={methodIntro:'',topics:[]};
    try{config=JSON.parse(root.querySelector('[data-em-landing-config]').textContent);}catch(e){}
    var $=function(s){return root.querySelector(s);};
    var scenes=[].slice.call(root.querySelectorAll('.scene'));
    var step=$('[data-step]'),selected=$('[data-selected-issue]'),typed=$('[data-typed]'),cursor=$('[data-cursor]');
    var persona=$('[data-persona]'),followup=$('[data-followup]');
    var journals=$('[data-phase="journals"]'),phases=[].slice.call(root.querySelectorAll('[data-phase]'));
    var finalTopic=$('[data-final-topic]');
    var methodTyped=$('[data-method-typed]'),methodCursor=$('[data-method-cursor]'),skip=$('[data-skip]');
    var appPath=root.dataset.appPath||'/apps/enlighten-me';
    var current=null,typingTimer=null,methodTimers=[],responseVersion=0;
    var mobile=function(){return window.matchMedia&&window.matchMedia("(max-width:760px)").matches;};

    // Shared session stores only a validated category id; never prose in URLs.
    function rememberEntry(){
      var storage;try{storage=sessionStorage;}catch{}
      var session=globalThis.EnlightenWelcomeSession.create(storage);
      session.enter('',{variant:'A',topic:current&&current.topic});
      analytics?.capture('Onboarding completed',{onceKey:'onboarding-completed'});
    }
    function enterCreator(){
      rememberEntry();
      var review=new URL(window.location.href).searchParams.get('welcomeIntegration')==='preview';
      window.location.assign(appPath+'?welcome=1'+(review?'&welcomeIntegration=preview&welcomeVariant=A':''));
    }
    function later(fn,ms){var id=setTimeout(fn,ms);methodTimers.push(id);return id;}
    function clearMethod(){methodTimers.forEach(clearTimeout);methodTimers=[];}
    function resetMethod(){
      clearMethod();
      if(skip)skip.hidden=true;
      if(methodTyped)methodTyped.textContent='';
      if(methodCursor)methodCursor.style.display='';
      phases.forEach(function(el){el.hidden=true;el.classList.remove('show','fade-out');});
    }
    function typeIntro(text,done){
      var i=0;
      if(reduced()){methodTyped.textContent=text;if(methodCursor)methodCursor.style.display='none';done&&done();return;}
      (function tick(){
        methodTyped.textContent=text.slice(0,i);
        if(i<text.length){i+=1;later(tick,44);}
        else{if(methodCursor)methodCursor.style.display='none';done&&done();}
      })();
    }
    function storyMoment(name){
      phases.forEach(function(el){
        if(el.dataset.phase===name){el.hidden=false;el.classList.remove('fade-out');el.classList.add('show');}
        else if(!el.hidden){el.classList.add('fade-out');later(function(){el.hidden=true;el.classList.remove('show','fade-out');},550);}
      });
      root.dataset.storyMoment=name;
    }
    function finishStory(){showStage(5);}
    function startMethod(){
      resetMethod();
      if(reduced()){finishStory();return;}
      skip.hidden=false;
      storyMoment('journals');
      typeIntro(config.methodIntro||'');
      // One continuous transformation, not additional tutorial screens.
      later(function(){storyMoment('notes');},3500);
      later(function(){storyMoment('talk');},7200);
      later(function(){storyMoment('paths');},9100);
      later(function(){storyMoment('mantra');},11100);
      later(finishStory,13500);
    }
    function showStage(n){
      var stage=String(n);
      if(stage==='2'){
        var choices=[].slice.call(root.querySelectorAll('[data-topic-index]'));
        var order=choices.map(function(_,i){return i;});
        for(var k=order.length-1;k>0;k--){var pick=Math.floor(Math.random()*(k+1)),swap=order[k];order[k]=order[pick];order[pick]=swap;}
        choices.forEach(function(b,i){b.style.setProperty('--choice-delay',(order[i]*2400/Math.max(1,choices.length-1))+'ms');if(mobile()&&!reduced())b.style.animation='none';});
      }
      root.dataset.stage=stage;
      scenes.forEach(function(s){s.classList.toggle('active',s.dataset.scene===stage);});
      // Commit the newly visible mobile screen before starting its entrance animations.
      if(stage==='2'&&mobile()&&!reduced()){
        void root.offsetWidth;
        requestAnimationFrame(function(){choices.forEach(function(b){b.style.removeProperty('animation');});});
      }
      if(stage==='4')startMethod();else resetMethod();
      if(stage==='5'){finalTopic.hidden=!current;finalTopic.textContent=current?current.label:'';}
      var top=root.getBoundingClientRect().top+window.pageYOffset;
      window.scrollTo({top:top,behavior:reduced()?'auto':'smooth'});
    }

    [].forEach.call(root.querySelectorAll('[data-first]'),function(btn){
      btn.addEventListener('click',function(){
        if(btn.dataset.first==='yes'){showStage(2);return;}
        [].forEach.call(root.querySelectorAll('[data-first]'),function(b){b.style.opacity='.48';});
        btn.style.opacity='1';
        step.disabled=false;step.classList.add('ready','show');
      });
    });
    step.addEventListener('click',function(){showStage(2);});

    function startResponse(index){
      var topic=config.topics[index];if(!topic)return;
      clearInterval(typingTimer);
      var version=++responseVersion;
      current=topic;
      selected.textContent=topic.label;
      typed.textContent='';cursor.style.display='';
      persona&&persona.classList.remove('typing');
      followup.hidden=true;followup.classList.remove('em-followup-arrive');
      showStage(3);
      var text=topic.reply||'';
      if(reduced()){typed.textContent=text;cursor.style.display='none';followup.hidden=false;return;}
      persona&&persona.classList.add('typing');
      var i=0;
      function beginTyping(){
      if(version!==responseVersion||root.dataset.stage!=="3")return;
      typingTimer=setInterval(function(){
        typed.textContent+=text[i]||'';i++;
        if(i>=text.length){
          clearInterval(typingTimer);
          setTimeout(function(){if(version!==responseVersion||root.dataset.stage!=="3")return;cursor.style.display='none';persona&&persona.classList.remove('typing');followup.hidden=false;followup.classList.add('em-followup-arrive');},150);
        }
      },32);
      }
      if(mobile()){requestAnimationFrame(function(){requestAnimationFrame(beginTyping);});}else beginTyping();
    }
    [].forEach.call(root.querySelectorAll('[data-topic-index]'),function(b){
      b.style.setProperty('--choice-order',b.dataset.topicIndex);
      b.addEventListener('click',function(){startResponse(Number(b.dataset.topicIndex));});
    });

    $('[data-followup-yes]').addEventListener('click',function(){showStage(4);});
    if(skip)skip.addEventListener('click',finishStory);
    $('[data-explore]').addEventListener('click',rememberEntry);
    $('[data-to-final]').addEventListener('click',enterCreator);
    if(root.dataset.stage==='4')startMethod();
    opening(root);

  }

  function initAll(){[].forEach.call(document.querySelectorAll('[data-em-landing]'),init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAll);else initAll();
  // The Theme Editor redraws a section when it is edited.
  document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-em-landing]'));});
})();
